import {useCallback} from 'react';
import {useNavigate} from 'react-router';
import {Paths} from '../../routes/paths';

type UsePostLogoutRedirectResult = () => void;

export function usePostLogoutRedirect(): UsePostLogoutRedirectResult {
  const navigate = useNavigate();
  return useCallback(() => void navigate(Paths.Login), [navigate]);
}
